import React, {useMemo} from 'react';
import {useSelector} from 'react-redux';

import {
    accountSearchResultCrmIntegrationDataSelector,
    accountSearchResultCrmIntegrationResultSelector,
} from '../../slices/account-search-result-crm-integration.slice';

type Props = {
    accountId: number,
};

export const HubSpotIntegrationCell = ({accountId}: Props) => {
    const {isLoading, loadingError} = useSelector(accountSearchResultCrmIntegrationDataSelector);
    const result = useSelector(accountSearchResultCrmIntegrationResultSelector);

    const hubspotEnabled = useMemo(() => {
        if (!result?.data[accountId]) {
            return undefined;
        } else {
            return result?.data[accountId].hubspotEnabled ? 'Yes' : 'No';
        }
    }, [result, accountId]);

    if (isLoading || loadingError || !hubspotEnabled) {
        return null;
    }

    return (
        <span>{hubspotEnabled}</span>
    );
};
